<template>
    <div class="notes-wrapper">
        <!-- Show preloader if loading -->
        <app-overlay-loader v-if="preloader || loader" />

        <!-- Notes Section -->
        <template v-else>
            <div v-if="notes.length" class="notes-container">
                <div v-for="(note, index) in notes" :key="index" class="note-card">
                    <div class="note-card-body">
                        <!-- Note Content -->
                        <p class="note-content">{{ note.note }}</p>

                        <!-- Added By (User) -->
                        <p v-if="note.added_by" class="note-meta">
                            <span class="text-muted">{{ $t('added_by') }}:</span>
                            {{ note.user.first_name }} {{ note.user.last_name }}
                        </p>

                        <!-- Created At (Date) -->
                        <p v-if="note.created_at" class="note-meta">
                            <span class="text-muted">{{ $t('created_at') }}:</span>
                            {{ new Date(note.created_at).toLocaleDateString() }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- No notes found message -->
            <p v-else class="no-notes">{{ $t('candidates.no_notes_found') }}</p>
        </template>
    </div>
</template>

<script>
import { axiosGet } from "../../../../../../../common/Helper/AxiosHelper";
import { mapState } from "vuex";

export default {
    name: "Note",
    data() {
        return {
            notes: [], // Holds notes data
            preloader: false, // Loader visibility
        };
    },
    methods: {
        // Fetch notes from the API
        getNotes() {
            this.preloader = true;
            axiosGet(`${this.apiUrl.CANDIDATES}/${this.candidateDetails.id}`).then(response => {
                this.notes = response.data.notes; // Set fetched notes
            }).finally(() => {
                this.preloader = false; // Hide loader
            });
        },
    },
    computed: {
        // Map state from Vuex
        ...mapState({
            loader: state => state.loading,
            candidateDetails: state => state.candidate.candidate,
        }),
    },
    watch: {
        'candidateDetails.id': {
            handler(id) {
                if (id) {
                    this.getNotes(); // Fetch notes when candidate ID is set
                }
            },
            immediate: true, // Run immediately when component is loaded
        },
    },
};
</script>

<style scoped>
.notes-wrapper {
    padding: 1rem;
    max-width: 1000px;
    margin: 0 auto;
}

.notes-container {
    display: grid;
    gap: 1rem;
}

.note-card {
    border: 1px solid;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s;
}

.note-card:hover {
    transform: translateY(-5px);
}

.note-card-body {
    padding: 1rem;
}

.note-content {
    font-size: 1rem;
    line-height: 1.6;
}

.note-meta {
    font-size: 0.875rem;
    margin-top: 0.5rem;
}

.no-notes {
    text-align: center;
}
</style>
